__turbopack_context__.v({
  "close": "KtXlIW_close",
  "copy": "KtXlIW_copy",
  "iconWrapper": "KtXlIW_iconWrapper",
  "root": "KtXlIW_root",
});
